import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import type { PosterAdminFilter } from "../../api/posters";

export const defaultPosterFilter: PosterAdminFilter = {};

interface CampaignOption {
    id: string;
    name: string;
}

export const PosterAdminTabs = (): JSX.Element => (
    <nav className="poster-admin__tabs" aria-label="Affischvyer">
        <NavLink
            end
            to="/admin/posters"
            className={({ isActive }) =>
                `poster-admin__tab${isActive ? " poster-admin__tab--active" : ""}`
            }
        >
            Statistik
        </NavLink>
        <NavLink
            end
            to="/admin/posters/vandalism"
            className={({ isActive }) =>
                `poster-admin__tab${isActive ? " poster-admin__tab--active" : ""}`
            }
        >
            Vandalisering
        </NavLink>
        <NavLink
            to="/admin/posters/vandalism/map"
            className={({ isActive }) =>
                `poster-admin__tab${isActive ? " poster-admin__tab--active" : ""}`
            }
        >
            Vandaliseringskarta
        </NavLink>
    </nav>
);

interface PosterAdminFiltersProps {
    filter: PosterAdminFilter;
    onChange: (filter: PosterAdminFilter) => void;
    campaigns: CampaignOption[];
    extra?: ReactNode;
}

export const PosterAdminFilters = ({
    filter,
    onChange,
    campaigns,
    extra
}: PosterAdminFiltersProps): JSX.Element => {
    const set = (key: keyof PosterAdminFilter, value: string) =>
        onChange({ ...filter, [key]: value || undefined });

    return (
        <div className="poster-admin__filters">
            <div className="filter-group">
                <label htmlFor="poster-campaign">Kampanj:</label>
                <select
                    id="poster-campaign"
                    className="filter-select"
                    value={filter.campaignId ?? ""}
                    onChange={(e) => set("campaignId", e.target.value)}
                >
                    <option value="">Alla kampanjer</option>
                    {campaigns.map((campaign) => (
                        <option key={campaign.id} value={campaign.id}>
                            {campaign.name}
                        </option>
                    ))}
                </select>
            </div>

            <div className="filter-group">
                <label htmlFor="poster-from">Från:</label>
                <input
                    id="poster-from"
                    type="date"
                    className="filter-input"
                    value={filter.from ?? ""}
                    onChange={(e) => set("from", e.target.value)}
                />
            </div>

            <div className="filter-group">
                <label htmlFor="poster-to">Till:</label>
                <input
                    id="poster-to"
                    type="date"
                    className="filter-input"
                    value={filter.to ?? ""}
                    onChange={(e) => set("to", e.target.value)}
                />
            </div>

            {extra}

            <button
                type="button"
                className="filter-clear-button"
                onClick={() => onChange(defaultPosterFilter)}
            >
                Rensa filter
            </button>
        </div>
    );
};
